import i18next from "i18next";

export const ActionListAdmin = [
  {
    value: i18next.t("grid.view_details"),
    action: "viewDetails",
  },
];

export const TestDataAdminList: any[] = [
  {
    stateName: "Andhra Pradesh",
    totalDistricts: 45,
    totalStateAdmin: 450,
    totalAsha: 3000,
    totalPatient: 100000,
  },
  {
    stateName: "Assam",
    totalDistricts: 45,
    totalStateAdmin: 450,
    totalAsha: 3000,
    totalPatient: 100000,
  },
  {
    stateName: "Bihar",
    totalDistricts: 96,
    totalStateAdmin: 234,
    totalAsha: 89573,
    totalPatient: 4500,
  },
  {
    stateName: "Gujrat",
    totalDistricts: 56,
    totalStateAdmin: 878,
    totalAsha: 89573,
    totalPatient: 4500,
  },
  {
    stateName: "Karnataka",
    totalDistricts: 45,
    totalStateAdmin: 450,
    totalAsha: 3000,
    totalPatient: 100000,
  },
  {
    stateName: "Madhya Pradesh",
    totalDistricts: 56,
    totalStateAdmin: 878,
    totalAsha: 89573,
    totalPatient: 4500,
  },
  {
    stateName: "Maharastra",
    totalDistricts: 45,
    totalStateAdmin: 8748,
    totalAsha: 56,
    totalPatient: 234545,
  },
  {
    stateName: "Rajasthan",
    totalDistricts: 56,
    totalStateAdmin: 878,
    totalAsha: 89573,
    totalPatient: 4500,
  },
  {
    stateName: "Uttar Pradesh",
    totalDistricts: 55,
    totalStateAdmin: 800,
    totalAsha: 56000,
    totalPatient: 67000,
  },
];

//  This is for reference purpose to be removed later
const mapData = (pokemon: any) => {
  const mappedData = {
    stateName: "Test2",
    totalDistricts: 56,
    totalStateAdmin: 878,
    totalAsha: 89573,
    totalPatient: 4500,
  };
  return mappedData;
};

export const serverConfig = {
  url: "https://pokeapi.co/api/v2/pokemon",
  then: (data: any) =>
    data.results.map((pokemon: any) => {
      const mappedData = {
        stateName: pokemon.name,
        totalDistricts: 56,
        totalStateAdmin: 878,
        totalAsha: 89573,
        totalPatient: 4500,
      };
      return mappedData;
    }),
  total: (data: any) => data.count,
};

export const paginationServer = {
  url: (prev: any, page: any, limit: any) =>
    `${prev}?limit=${limit}&offset=${page * limit}`,
};

export const STATUS = [
  { label: "Active", value: "Active" },
  { label: "Inactive", value: "Inactive" },
];

export const TestData: any[] = [
  {
    adminName: "Ram",
    adminId: "AD-457",
    phoneNumber: "572957259",
    districts: "Bellary",
    status: "Active",
  },
  {
    adminName: "Jhon",
    adminId: "AD-682",
    phoneNumber: "2375872",
    districts: "Bidar",
    status: "Inactive",
  },
];

export const TestAdminDistrictList: any[] = [
  {
    districts: "Bellary",
    totalAshas: 158,
    totalPatients: 34659,
  },
  {
    districts: "Bidar",
    totalAshas: 78,
    totalPatients: 1236,
  },
  {
    districts: "Mysore",
    totalAshas: 784,
    totalPatients: 12642,
  },
  {
    districts: "Mangalore",
    totalAshas: 313,
    totalPatients: 34609,
  },
  {
    districts: "Vijaynagar",
    totalAshas: 118,
    totalPatients: 4659,
  },
  {
    districts: "Kodagu",
    totalAshas: 158,
    totalPatients: 34659,
  },
];

export const AshaDetails = [
  {
    name: "Usha",
    ashaID: "VW-6537",
    phoneNumber: "56238256285",
    cityVillage: "Ramnagar",
    district: "Bellary",
    status: "Active",
  },
  {
    name: "Kavya",
    ashaID: "VW-67",
    phoneNumber: "748724921",
    cityVillage: "Banashankari",
    district: "Bellary",
    status: "Active",
  },
];

export const PatientDetails = [
  {
    name: "Usha",
    patientID: "RCH/675",
    phoneNumber: "865289562",
    cityVillage: "Ramnagar",
    district: "Bellary",
  },
  {
    name: "Kavya",
    patientID: "RCH/575",
    phoneNumber: "845862892",
    cityVillage: "Banashankari",
    district: "Bellary",
  },
  {
    name: "Aman",
    patientID: "RCH/75",
    phoneNumber: "6482689422",
    cityVillage: "Sira",
    district: "Bidar",
  },
  {
    name: "Riya",
    patientID: "RCH/275",
    phoneNumber: "836582356",
    cityVillage: "Hesarghatta",
    district: "Kolar",
  },
  {
    name: "Ranveer",
    patientID: "RCH/835",
    phoneNumber: "376978352",
    cityVillage: "Djhalli",
    district: "Mysore",
  },
];

export const ActionList = [
  {
    value: "View Details",
    action: "viewDetails",
  },
  {
    value: "Deactivate",
    action: "deactivate",
  },
];

export const TestUserDataASHA = {
  idDetails: "ID - VW-12345",
  age: "25",
  birthOfDate: "01-01-1992",
  phoneNumber: "8645347895",
  gender: "female",
};

export const TestDataAsha = {
  personalInformation: [
    {
      title: "Marital Status",
      data: "Married",
    },
    {
      title: "Husband's Name",
      data: "Harish Chand",
    },
  ],
  Address: [
    {
      title: "Village/Slum",
      data: "Gogol",
    },
    {
      title: "District/Block",
      data: "Mumbai",
    },
    {
      title: "State",
      data: "State",
    },
    {
      title: "Pincode",
      data: "235678",
    },
  ],
  AssignLocation: [
    {
      title: "Village",
      data: ["Gogol", "Itayira", "Bahadurpur"],
    },
    {
      title: "Sub Centre",
      data: ["Bhoorbaral"],
    },
    {
      title: "UHPC/PHC",
      data: ["Bhoorbaral"],
    },
  ],
  count: [
    {
      title: "Total Patients ",
      data: "50",
    },
    {
      title: "Total Screening",
      data: "100",
    },
  ],
  state: [
    {
      title: "State name",
      data: "Uttarpradesh",
    },
    {
      title: "List of Districts (7 Districs)",
      data: [
        "Gogol",
        "Itayira",
        "Bahadurpur",
        "Bhoorbaral",
        "Fatehpur",
        "Pratapgarh",
      ],
    },
  ],
};

export const mockCityVillage = [
  { label: "Ramnagar", value: "Ramnagar" },
  { label: "Banashankari", value: "Banashankari" },
  { label: "Sira", value: "Sira" },
  { label: "Hesarghatta", value: "Hesarghatta" },
  { label: "Djhalli", value: "Djhalli" },
  { label: "Jaynagar", value: "Jaynagar" },
];
